import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  ListItem,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { Enumerations } from "../../config/Enumerations";
import { CiFileOn } from "react-icons/ci";
import { VscOpenPreview } from "react-icons/vsc";
import { LiaDownloadSolid } from "react-icons/lia";
import { AppEntryAttachmentsRepository } from "../repositories/AppEntryAttachmentsRepository";
import PDFDialogViewer from "../common/PdfDialogViewer";
import React from "react";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { useDispatch } from "react-redux";
import { SETTINGS } from "../../Settings";

export default function EntryAttachedDocuments({ attachedDocuments }) {
  const theme = useTheme();
  const [previewPdf, setPreviewPdf] = React.useState(null);
  const [imagePreview, setImagePreview] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const dispatch = useDispatch();
  const [dwgPreview, setDwgPreview] = React.useState(null);

  const previewAttachment = (attachment) => {
    console.log(attachment);
    AppEntryAttachmentsRepository.getAttachment(attachment.id).then(
      (response) => {
        const file = new Blob([response.data], { type: response.data.type });
        if (attachment.fileType === "application/pdf") {
          setPreviewPdf(file);
        }
        if (attachment.fileType.startsWith("image/")) {
          setImagePreview(URL.createObjectURL(file));
        }
        // TODO: implement DWG preview
        // if (
        //   attachment.fileType.startsWith("application/octet-stream") &&
        //   attachment.fileName.endsWith(".dwg")
        // ) {
        //   setDwgPreview(URL.createObjectURL(file));
        //   window.open(
        //     "https://sharecad.org/cadframe/load?url=" +
        //       URL.createObjectURL(file),
        //     "_blank"
        //   );
        // }
      }
    );
  };

  const downloadAttachment = (attachment) => {
    setSaving(true);
    const url = `${SETTINGS.EXTERNAL_API_URL}external/appEntries/attachments/${
      attachment?.id
    }?token=${localStorage.getItem("accessToken")}`;

    console.log("Downloading from URL:", url);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", attachment?.fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setSaving(false);
  };

  return (
    <Grid item xs={12} md={6}>
      <Paper
        elevation={3}
        sx={{ padding: 2, backgroundColor: theme.palette.primary.main }}
      >
        <div className="attached-documents-header">
          <Typography variant="h6" className="header-text">
            Прикачени документи
          </Typography>
        </div>
        <Box className="attached-documents-box">
          {attachedDocuments?.map((attachment, index) => (
            <ListItem key={index} className="document-item light-border">
              <div className="document-icon">
                <CiFileOn color="#fff" size={25} />
              </div>
              <div className="document-details">
                <Typography variant="inherit" className="document-type light">
                  {Enumerations.DocumentType[attachment.documentType] ||
                    attachment.type}
                </Typography>
                <Typography variant="inherit" className="document-name light">
                  {attachment.fileName}
                </Typography>
              </div>
              <div className="document-actions">
                <IconButton
                  className="document-icon-button"
                  onClick={() => downloadAttachment(attachment)}
                >
                  <LiaDownloadSolid color="#fff" />
                </IconButton>
              </div>
            </ListItem>
          ))}
        </Box>
      </Paper>

      {saving && (
        <Backdrop open={true} sx={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Grid>
  );
}
